<template>
  <div class="default-modal" v-loading="loading">
    <el-dialog
      width="60%"
      top="15vh"
      v-model="exportReportsDialogVisisble"
      @close="close"
    >
      <div class="export-dialog-header">
        <div class="export-header-part"><h3>RESULT FILES REPORTS</h3></div>
        <el-button
          size="medium"
          class="el-white"
          type="info"
          plain
          @click="close"
        >
          <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
        /></el-button>
      </div>
      <div class="selected-string" v-if="selected_case_type">
        <h3>
          Selected caseType :
          <span>{{ getCaseTypeMap(selected_case_type) }} </span>
        </h3>
      </div>
      <div
        class="selected-string"
        v-if="search_case_status && search_case_status.length"
      >
        <h3>
          Selected Status :
          <span v-if="search_case_status != 'TO-START'"
            >{{ getStatusMap(search_case_status) }}
          </span>
          <span v-else>
            {{ search_case_status == "TO-START" ? "To Start" : "" }}</span
          >
        </h3>
      </div>
      <div class="export-include-select-field">
        <h4 class="check-all-sub-title">DATA INCLUDES :</h4>

        <el-checkbox
          class="search-checkbox"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >Check All</el-checkbox
        >
      </div>
      <div class="dialog-body">
        <div class="export-popup-body mt-0" v-loading="loading">
          <el-checkbox-group v-model="activeFieldList" @change="isCheckAll">
            <ul class="select-fields-list">
              <li
                class="search-checkbox"
                v-for="(item, index) in exportResultExcelFields"
                :key="index"
              >
                <el-checkbox :label="item.value">
                  {{ item.label }}
                </el-checkbox>
              </li>
            </ul>
          </el-checkbox-group>
        </div>
      </div>
      <div class="dialog-footer export-footer w-95">
        <el-button class="cancel-button" @click="close">CANCEL</el-button>
        <el-button class="blue-save-button" @click="downloadCases">
          DOWNLOAD
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import AppHelper from "@/mixins/AppHelper";
import exportResultFilesHelper from "@/mixins/exportResultFilesHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
export default {
  mixins: [
    UserPermissionsHelper,
    exportResultFilesHelper,
    caseDataHelper,
    AppHelper,
    FilterHelper,
  ],
  props: ["search_case_status", "selected_case_type"],
  computed: {
    ...mapGetters("respiratoryFileUpload", ["getDownloadResultFilesStatus"]),

    getCaseTypeMap() {
      return (status) => this.caseTypeMap[status];
    },
    getStatusMap() {
      return (status) => this.statusMap[status];
    },
  },
  data() {
    return {
      exportReportsDialogVisisble: true,
      fieldList: [],
      activeFieldList: [],
      checkAll: true,
      loading: false,
      status: "",
      statusMap: {
        ACTIVE: "Active",

        PROCESSING: "Processing",
        FAILED: "Failed",
        COMPLETED: "Completed",
        ARCHIVED: "Archived",
      },

      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  async mounted() {
    this.loading = true;
    this.loadFieldsList();
    this.status = this.search_case_status;

    this.loading = false;
  },
  methods: {
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportResultExcelFields &&
        this.activeFieldList.length &&
        this.exportResultExcelFields.length &&
        this.activeFieldList.length == this.exportResultExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    async downloadCases() {
      if (this.activeFieldList.length) {
        let params = {
          include: this.activeFieldList,
        };

        if (this.search_case_status != "") {
          params.status = this.search_case_status;
        }

        if (this.selected_case_type != "") {
          params.case_type = this.selected_case_type;
        }

        this.loading = true;
        await this.$store.dispatch(
          "respiratoryFileUpload/downloadResultFilesData",
          params
        );
        this.loading = false;
        if (this.getDownloadResultFilesStatus) {
          this.close();
        } else {
          this.$message({
            message: "Error in downloading resultfiles",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
    loadFieldsList() {
      this.exportResultExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },

    close() {
      this.$emit("close");
    },
    handleCheckAllChange(val) {
      this.activeFieldList = val ? this.fieldList : [];
    },
  },
};
</script>
<style lang="scss" scoped></style>
